import React, { useCallback } from "react";

import Memo from "Payments/PaymentPage/PaymentFormScreen/MemoSection/Memo";

import { useRecurringGifts } from "../../RecurringGiftsContext";

export default function MemoSection() {
  const { state, dispatch } = useRecurringGifts();

  const { memoEnabled } = state?.editModal?.giftDetails?.fund;

  const removeMemo = useCallback(() => {
    dispatch({ type: "updateMemo", payload: null });
  }, [dispatch]);

  const updateMemo = useCallback(
    (text) => {
      dispatch({ type: "updateMemo", payload: text });
    },
    [dispatch]
  );

  if (!memoEnabled) return null;

  return (
    <Memo
      onRemoveMemo={removeMemo}
      onUpdateMemo={updateMemo}
      initialContent={state.editModal?.currentGift?.memo}
      hasHorizontalMargin={false}
    />
  );
}
